import { STEPS } from 'hb-react/shared/apps/Memberships/containers/PurchaseMembership/constants';
import { CART_ITEM_TYPES } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';

export const getBreadcrumbs = ({
  currentStep,
  setCurrentStep,
  withPaymentStep = true,
}) => {
  if (currentStep === STEPS.SUCCESS) {
    return;
  }

  return [
    {
      name: __('Registration'),
      onClick: () => {
        setCurrentStep(STEPS.REGISTRATION);
      },
      active: currentStep === STEPS.REGISTRATION,
    },
    ...(withPaymentStep
      ? [
          {
            name: __('Billing Information'),
            onClick: () => {
              setCurrentStep(STEPS.BILLING);
            },
            active: currentStep === STEPS.BILLING,
            requiredExplanation: true,
            disabled: currentStep === STEPS.REGISTRATION,
          },
          {
            name: __('Payment'),
            disabled: true,
          },
        ]
      : []),
  ];
};

export const addShoppingCardItemsActions = ({
  item,
  currentPage,
  setCurrentStep,
  actions,
}) => {
  if (item.line_itemable_type === CART_ITEM_TYPES.DONATION) {
    return {
      ...item,
      ...(currentPage !== STEPS.SUCCESS
        ? {
            onEdit: () => {
              setCurrentStep(STEPS.DONATIONS);
            },
          }
        : []),
    };
  }

  if (item.line_itemable_type === CART_ITEM_TYPES.PROMO_CODE) {
    return {
      ...item,
      onDelete: () => {
        actions.items.remove(item.id);
      },
    };
  }

  return item;
};

export const getPromoCodeIds = (cartItems) =>
  cartItems
    .map((item) => {
      if (item.line_itemable_type === CART_ITEM_TYPES.PROMO_CODE) {
        return item.id;
      }

      return null;
    })
    .filter(Boolean);
